module.exports = "https://static.cdns.space/classicbook-temp-tx/img/4-3.bcb874e7.jpg";